module.exports = __webpack_public_path__ + "00ae4e73cc902efd834cd13c4db05123.svg";